type Props = {
  className?: string;
};

export const BookedNotInUse = (props: Props) => {
  return (
    <svg
      {...props}
      width={40}
      height={41}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.3169 35.3139C16.0512 35.4277 15.751 35.4303 15.4834 35.3213L1.04186 29.4392C0.152546 29.077 0.141404 27.8217 1.02415 27.4438L23.6832 17.7423C23.9488 17.6285 24.249 17.6259 24.5166 17.7349L38.9582 23.617C39.8475 23.9792 39.8586 25.2345 38.9759 25.6124L16.3169 35.3139Z"
        fill="black"
        fillOpacity={0.06}
      />
      <path
        d="M36.5813 22.2688C36.927 22.4096 37.093 22.8039 36.9523 23.1496C36.8115 23.4953 36.4171 23.6614 36.0714 23.5206L32.0984 21.9024L30.1119 21.0932L32.6083 20.6506L36.5813 22.2688Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7051 14.0508L32.7051 21.62L31.3535 21.62L31.3535 14.0508L32.7051 14.0508Z"
        fill="black"
      />
      <path
        d="M16.9341 27.8125C16.2733 28.0909 15.529 28.0954 14.8649 27.8249L2.27044 22.6951C0.93229 22.1501 0.920969 20.2593 2.2525 19.6983L23.6072 10.7008C24.268 10.4224 25.0124 10.418 25.6765 10.6884L38.2709 15.8182C39.6091 16.3632 39.6204 18.254 38.2889 18.8151L16.9341 27.8125Z"
        fill="#E9CD44"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.77974 21.4434L15.3742 26.5731C15.7062 26.7084 16.0784 26.7061 16.4088 26.5669L37.7635 17.5695C37.8365 17.5387 37.8696 17.5019 37.889 17.4709C37.9123 17.4335 37.9292 17.3807 37.9289 17.3188C37.9285 17.2568 37.9109 17.2042 37.8872 17.1671C37.8674 17.1363 37.8339 17.0999 37.7605 17.07L25.1661 11.9403C24.834 11.805 24.4619 11.8072 24.1315 11.9464L2.77675 20.9439C2.70374 20.9747 2.67066 21.0115 2.65129 21.0425C2.62795 21.0799 2.61102 21.1327 2.61139 21.1946C2.61176 21.2566 2.62933 21.3092 2.65311 21.3463C2.67284 21.377 2.70637 21.4135 2.77974 21.4434ZM14.8643 27.8249C15.5284 28.0954 16.2728 28.0909 16.9336 27.8125L38.2883 18.8151C39.6198 18.2541 39.6085 16.3633 38.2704 15.8182L25.6759 10.6885C25.0118 10.418 24.2675 10.4224 23.6067 10.7009L2.25195 19.6983C0.920426 20.2593 0.931746 22.1501 2.2699 22.6952L7.56479 24.8518L7.56479 30.4129L4.84658 29.3057C4.50091 29.1649 4.10656 29.331 3.96577 29.6767C3.82498 30.0224 3.99106 30.4167 4.33673 30.5575L7.56479 31.8723V31.8933H7.61629L12.2828 33.794C12.6284 33.9348 13.0228 33.7687 13.1636 33.423C13.3044 33.0773 13.1383 32.683 12.7926 32.5422L8.91641 30.9634L8.91641 25.4023L14.8643 27.8249Z"
        fill="black"
      />
      <g filter="url(#filter0_d_2124_61938)">
        <rect
          x={10}
          y={3}
          width={19}
          height={19}
          rx={9.5}
          fill="#C4A934"
        />
        <rect
          x={10.6333}
          y={3.63333}
          width={17.7333}
          height={17.7333}
          rx={8.86667}
          stroke="white"
          strokeWidth={1.26667}
        />
        <path
          d="M19.666 14.3359V13.9691C19.666 13.3768 20.0057 12.8369 20.5397 12.5806C21.7694 11.9903 21.6815 10.2108 20.3996 9.74469L20.233 9.68412C19.2586 9.32979 18.2075 9.97252 18.0789 11.0013L17.9961 11.664"
          stroke="white"
          strokeWidth={0.890625}
          strokeLinecap="round"
        />
        <circle
          cx={19.666}
          cy={16.8965}
          r={0.333984}
          fill="white"
          stroke="white"
          strokeWidth={0.296875}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2124_61938"
          x={5}
          y={0}
          width={29}
          height={29}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2124_61938"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2124_61938"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
